<template>
  <md-list class="md-triple-line md-scrollbar">
    <md-list-item class="md-primary" v-for="seat, i in getSelectedSeats">
      <md-avatar :class="`md-avatar-icon md-accent md-medium s-${seat.status}`">{{ seat.seatID }}</md-avatar>
      <div class="md-list-item-text">
        <span>{{ seat.row.title }}</span>
        <p>
          {{ seat.row.position }} {{ seat.rowNumber }} / {{ seat.orientation }} / <span v-if="!discount">{{ formatCurrency(seat.price) }}</span><span v-else>{{ formatCurrency(seat.discount) }}</span>
        </p>
      </div>
      <md-button class="md-icon-button md-list-action" v-on:click="toggleSeatState([seat.rowID, seat.seatID])">
        <md-icon class="md-primary">close</md-icon>
      </md-button>
    </md-list-item>
    <md-divider></md-divider>
  </md-list>
</template>

<script>
import {mapGetters} from 'vuex'
import FormatCurrency from '../../../mixins/format-currency';

export default {
  props: ['discount'],
  mixins: [FormatCurrency],

  computed:{
    ...mapGetters([
      'getSelectedSeats',
    ]),
  },

  methods:{
    toggleSeatState(data){
      this.$store.dispatch('toggleSeatState', data);
    },
  }
}
</script>

<style lang="scss">
.selected-seats{
  position: absolute;
  top: 0;
  right: 30px;
  width: 300px;
  .md-list-item{
    display: block;
  }

  .md-list{
    max-height: calc(100vh - 350px);
    overflow-y: scroll;
    padding-bottom: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Admin/Theatre/SelectedSeats.vue